import { vendorMeWithOutNetworkCheck } from '@services/vendor';
import { useQuery } from '@tanstack/react-query';
import getToken from '@utils/auth/getToken';

export const useGetVendorWithNetworkStatus = () =>
  useQuery({
    queryKey: ['vendorMeWithNetworkStatus'],
    queryFn: () => vendorMeWithOutNetworkCheck(),
    select: (data) => data.data,
    cacheTime: Infinity,
    networkMode: 'offlineFirst',
    enabled: !!getToken(),
  });
